import EmpleadoTable from "./EmpleadoTable";
import CardLayout from "../Layout/CardLayout";
import React from "react";
import CostoFijosTable from "./CostoFijosTable";

const CostoSemifijo = (ciemId) => {

    const contributionForm =
        <CostoFijosTable optionName={"costoSemifijoTable"}
                         ciemId={ciemId}
                        />
    ;

    return (
        <div className="container-fluid">
            <CardLayout value={"costoSemifijoTitulo"} tablaComponent={contributionForm} />
        </div>
    );
};

export default CostoSemifijo;